import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'

const useEmbedThemeProperties = (properties: string[] = []) => {
  const theme = useSelector(state => pathOr({}, ['embed', 'configuration', 'theme'], state))

  const propertyValueMap: any[] = properties.map(property => theme[property])
  return propertyValueMap
}

export default useEmbedThemeProperties